// src/components/Footer.js
import React from 'react';
import '../styles/BellaBizarreStyle.css';

function Footer() {
    return (
        <footer className="footer">
            <p>Developed by <a href="https://www.kylehintonprojects.com/" target="_blank" rel="noreferrer" >The Simulacrum</a>, Kyle Hinton</p>
        </footer>
    );
}

export default Footer;
